import React from 'react';
import { useHistory } from 'react-router';
import { Main } from '@klp/layout/Main';
import { Block } from '@klp/design/Block';
import { ActionLink } from '@klp/design/Action';
import { Heading } from '@klp/design/Heading';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { ProsjektRoutes } from '@klp/prosjekt/config';
import { useProsjektSammendragContext } from './context/ProsjektSammendragProvider';

const styles = () => ({
    notFoundContainer: {
        alignSelf: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '60%',
    } as const,
});

export const ProsjektSammendragError: React.FC = () => {
    const classes = useKlpStyles({}, styles);
    const history = useHistory();
    const { invalidateProcess } = useProsjektSammendragContext();

    const handleBack = () => {
        invalidateProcess();
        history.push(ProsjektRoutes.projectSchema());
    };

    const backHref = ProsjektRoutes.projectSchema();

    return (
        <Main fullScreen={true}>
            <Block>
                <ActionLink
                    actionType="linkBack"
                    translation="project.backButton"
                    onClick={handleBack}
                    href={backHref}
                />
            </Block>
            <Block className={classes.notFoundContainer} paddingTop="massive">
                <Illustration
                    paddingBottom="compact"
                    icon={IconName.CIRCLE_OBS}
                    size="xxxlarge"
                />
                <Heading
                    klpHeadingLevel="TWO"
                    klpColor="dark"
                    translation="project.notFound"
                    data-testid="Prosjekt__NotFound__Title"
                />
            </Block>
        </Main>
    );
};
